import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import template from './palettePickerDialog.jsx';
import displayNames from '../displayNames';

var PalettePickerDialog = function PalettePickerDialog(props) {
  return template(props);
};

PalettePickerDialog.displayName = displayNames.PALETTE_PICKER_DIALOG;
PalettePickerDialog.propTypes = {
  textKeys: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  palettePresets: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))),
  onChange: PropTypes.func
};
PalettePickerDialog.defaultProps = {
  textKeys: {}
};
export default compose(PalettePickerDialog);